import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useReprocess } from "@/context/reprocess-context";
import { AlertCircle, CheckCircle2, RefreshCw } from "lucide-react";

export const ReprocessCompletedModal = () => {
  const { reprocessCompleted, reprocessFailed, acknowledgeCompletion } = useReprocess();

  return (
    <AlertDialog open={reprocessCompleted}>
      <AlertDialogContent
        onEscapeKeyDown={(e) => e.preventDefault()}
        className="sm:max-w-md"
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            {reprocessFailed ? (
              <>
                <AlertCircle className="h-5 w-5 text-red-600" />
                Erro no Reprocessamento
              </>
            ) : (
              <>
                <CheckCircle2 className="h-5 w-5 text-green-600" />
                Reprocessamento Concluído
              </>
            )}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {reprocessFailed
              ? "O reprocessamento falhou. Clique para atualizar a tela. Verifique as notificações para mais detalhes."
              : "Os dados foram reprocessados com sucesso. Clique para atualizar a tela com os novos dados."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={acknowledgeCompletion}>
            <RefreshCw className="h-4 w-4 mr-2" />
            Atualizar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
